export default __webpack_public_path__ + "static/media/instagram.8868c689.svg";